/*
  Sail Workshop — benzer ürünler şeridi: ok butonları ve döngü.

  Bu bölümün içeriği AJAX ile sonradan geliyor ve HTML baştan yazılıyor;
  bu yüzden script bölümün dışında yüklenir ve DOM değişimini izleyerek
  yeni gelen şeride kendini bağlar.
*/
(function () {
  function bindAll() {
    document.querySelectorAll('[data-related-carousel]').forEach(setup);
  }

  function setup(viewport) {
    if (viewport.dataset.bound === 'true') return;

    var track = viewport.querySelector('.related-carousel');
    var buttons = viewport.querySelectorAll('[data-related-nav]');
    if (!track || !buttons.length) return;

    viewport.dataset.bound = 'true';

    function maxScroll() {
      return track.scrollWidth - track.clientWidth;
    }

    function step() {
      var item = track.querySelector('.grid__item');
      return item ? item.getBoundingClientRect().width + 18 : track.clientWidth * 0.8;
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var isNext = btn.dataset.relatedNav === 'next';
        var limit = maxScroll();

        if (isNext && track.scrollLeft >= limit - 4) {
          track.scrollTo({ left: 0, behavior: 'smooth' });        // sona gelince başa sar
        } else if (!isNext && track.scrollLeft <= 4) {
          track.scrollTo({ left: limit, behavior: 'smooth' });    // baştayken sona sar
        } else {
          track.scrollBy({ left: isNext ? step() : -step(), behavior: 'smooth' });
        }
      });
    });

    function sync() {
      var scrollable = track.scrollWidth > track.clientWidth + 4;
      buttons.forEach(function (btn) { btn.hidden = !scrollable; });
    }

    window.addEventListener('resize', sync);
    sync();
  }

  function start() {
    bindAll();

    // AJAX ile gelen içeriği yakala
    var observer = new MutationObserver(function () { bindAll(); });
    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', bindAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
